import { render } from "./ivania.vue?vue&type=template&id=22127bf7"
import script from "./ivania.vue?vue&type=script&lang=js"
export * from "./ivania.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__